export default __webpack_public_path__ + "static/media/news66.eecb8b40.jpg";